import {$t} from "../../../helpers/translator";
import Menu from "../../../components/miscellaneous/Menu/Menu";
import {FaClinicMedical, FaChartBar, FaTools, FaCog, FaFileAlt} from 'react-icons/fa';
import machineWhite from '../../../assets/alma-icons/machineWhite.png'
import handleWhite from '../../../assets/alma-icons/handleWhite.png'

const DistributorMenu = () => {
    const items = [
        {name: $t('global.menu.dashboard'), icon: <FaChartBar />, path: '/', pathIncludes: '/dashboard'},
        {name: $t('global.menu.clinicsAndChains'), icon: <FaClinicMedical />, path: '/clinics', pathIncludes: '/clinic/'},
        {name: $t('global.menu.equipment'), icon: <FaCog />, path: null, children: [
            {name: $t('global.menu.platforms'), icon: machineWhite, path: '/equipment/platforms', pathIncludes: '/platform/'},
            {name: $t('global.menu.applicators'), icon: handleWhite, path: '/equipment/applicators', pathIncludes: '/applicator/'},
        ]},
        {name: $t('global.menu.reports'), icon: <FaFileAlt />, path: '/reports', pathIncludes: '/report/'},
        {name: $t('global.menu.service'), icon: <FaTools />, path: '/service', exact: true},
    ]

    return (
        <Menu items={items} userType={4} />
    )
};

export default DistributorMenu;
